import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiservicesService } from '../apiservices.service';
import { EncryptdecryptService } from './encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from '../app-config';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  ReturnValue: boolean = false;
  
  constructor(
    private API: ApiservicesService, 
    private encryptDecryptService: EncryptdecryptService,
    @Inject(APP_CONFIG) private config: AppConfig
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkRole(route);
  }

  async checkLogin() {
    const MyTaxAddress = this.config.MyTaxAddress; // <-- Load from config
    const result = await this.API.RequestToken();
    if (result.headers.get('Taefauth') === null) {
        alert("Please login auth");
        document.location.href = MyTaxAddress;
    } else {
      sessionStorage.removeItem('JWTToken');
      sessionStorage.setItem('JWTToken', this.encryptDecryptService.encrypt(result.headers.get('Taefauth') || ''));
    }
    return true;
  }

  async checkRole(route: ActivatedRouteSnapshot): Promise<boolean> {
    await this.checkLogin(); //Check if user is logged in from mytax
    let Allow = false;
    if (route.routeConfig?.path === '' || route.routeConfig?.path === 'utama') {
      return true;
    }
    var UserRoles = JSON.parse(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffRoles') || '{}'));
    let ExpectedRoles = route.data['expectedRoles'];

    UserRoles.forEach((currentValue: any, indexSecond: any) => {
      if (ExpectedRoles.indexOf(currentValue) > -1) {
        Allow = true;
      }
    });

    if(!Allow)
      alert("Anda tidak mempunyai akses bagi halaman ini");

    return Allow;
  }
}
